import filled_tick from 'src/assets/filled-tick.png';
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo_brand from 'src/assets/logo_brand.png'
import payment_options from 'src/assets/payment_options.png';
import paywall_cross from 'src/assets/paywall-cross.png';
import premium_lady from 'src/assets/premium-lady.png';
import premium_logo from 'src/assets/premium_logo.png';
import review_image1 from 'src/assets/review_image1.png';
import review_image2 from 'src/assets/review_image2.png';
import review_image3 from 'src/assets/review_image3.png';
import review_image4 from 'src/assets/review_image4.png';
import stripe_logo from 'src/assets/stripe_logo.png';
import submit_button_purple from 'src/assets/submit_button_purple.png';
import tick_light from 'src/assets/tick-light.png';
import unlimited_star from 'src/assets/unlimited_star.png';

import CloseIcon from '@mui/icons-material/Close';
import { useContext, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { advertisementImage, currency_list } from 'src/consumer/constants';
import { LocalizationContext } from 'src/consumer/context/LocalizationContext';
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext';
import confirmationTickLottie from 'src/consumer/lotties/confirmationTickLottie.json';
import { mediaURL } from 'src/consumer/services';
import { putDataWithParams } from 'src/consumer/services/featureServices';
import { makePayment } from 'src/consumer/services/paymentService';
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions';
import { GenericDisplayFlex } from 'src/mentor/layout/Styles';
import {
  ErrorMessage,
  GiftCardInput,
  GiftCodeInputContainer,
  GiftCodeSubmitButton,
  HeadingConfirmationPage,
  PaymentMethodBox,
  PaymentOptionImage,
  PaymentOptionName,
  SubheadingPaymentsPage,
  TickLottie,
} from '../EventBooking/EventBookingStyles';
import { GenericHeaderBackButton } from '../UserActivityPage/MyPlanComponents';
import {
  Advertisement,
  BilledAnnualText,
  BoxHeading,
  BusinessText,
  BusinessTextHeading,
  BusinessTextSubHeading,
  CloseIconContainer,
  CompanyLogo,
  ComparisonButton,
  ComparisonContainer,
  ComparisonLeftText,
  ComparisonMidText,
  ComparisonRightText,
  ComparisonTile,
  ComparisonTitle,
  ContactButton,
  ContainerForBusiness,
  ListContainer,
  LowerContainer,
  PaymentMethodsContainerInPrewall,
  PlanBox,
  PlanFlow,
  PlanFlowSubtitle,
  PlanFlowTitle,
  PlanLogo,
  PlanPrice,
  PlanTitle,
  PlanValiditySelection,
  PremiumButton,
  PremiumMaskot,
  PrewallLanding,
  PriceBox,
  ReviewBoxFirst,
  ReviewBoxFourth,
  ReviewBoxImage,
  ReviewBoxLower,
  ReviewBoxSecond,
  ReviewBoxThird,
  ReviewBoxUpper,
  ReviewName,
  StyledPrewallDrawer,
  TestimonialContainer,
  TestimonialHeading,
  TestimonialSubHeading,
  TickList,
  UpperContainer,
  ValidityBox,
  ValidityText,
  VideoContainer,
} from './PrewallAndPaywallStyles';

const PrewallAndPaywall = ({
  secureData,
  id,
  toggleWall,
  wallIsOpen,
  customPlans,
  afterSubmissionPlanFunction,
  onSuccessfulPaymentFunction,
}) => {
  const [validityState, setValidityState] = useState(customPlans ? 'custom' : undefined)
  const [pageState, setPageState] = useState('choose_plan')
  const [giftCode, setGiftCode] = useState('')
  const [paymentMethodLoading, setPaymentMethodLoading] = useState(null)
  const [giftCodeError, setGiftCodeError] = useState()

  const pageId = 'paywallPage'

  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)
  const localizedStrings = localizedData?.[pageId]

  let mapping = (secureData?.prewallMappings || []).find((map) => map?.id === id)
  const prewallObject = (secureData?.prewalls || []).find(
    (prewall) => prewall?.id === mapping?.prewallId,
  )
  let testimonials = secureData?.subscriptionTestimonials || []

  let plans = customPlans ? [customPlans] : secureData?.webSubscriptionGrpV2?.upgrade?.plans || []

  let monthlyPlanObject = (plans || []).find((plan) => plan[0]?.validity === 30)
  let yearlyPlanObject = (plans || []).find((plan) => plan[0]?.validity === 365)

  const { unSecureSetupData } = useContext(UnsecureSetupContext)

  const masterListAllowedPaymentMethods = unSecureSetupData?.subscriptionPaymentMethods || []

  const [paymentMethod, setPaymentMethod] = useState('upi')

  const closeWall = () => {
    setPageState('choose_plan')
    setGiftCode('')
    setGiftCodeError()
    setPaymentMethodLoading(null)
    toggleWall()
  }

  useEffect(() => {
    if (monthlyPlanObject) {
      setValidityState('monthly')
    }
    if (yearlyPlanObject) {
      setValidityState('yearly')
    }
  }, [monthlyPlanObject, yearlyPlanObject])

  let planToShow

  if (validityState === 'custom') {
    planToShow = customPlans?.[0]
  }
  if (validityState === 'yearly') {
    planToShow = yearlyPlanObject?.[0]
  } else if (validityState === 'monthly') {
    planToShow = monthlyPlanObject?.[0]
  }

  function handlePaymentMethodClick(gateway) {
    if (!Boolean(paymentMethodLoading)) {
      makePayment(
        planToShow?.id,
        paymentMethod,
        gateway,
        planToShow?.subscriptionSuccessMsg,
        closeWall,
        onSuccessfulPaymentFunction ? onSuccessfulPaymentFunction : () => null,
        (text) => setPaymentMethodLoading(text),
      )
    }
  }

  return (
    <StyledPrewallDrawer
      className="drawer"
      anchor="bottom"
      open={wallIsOpen}
      transitionDuration={{ enter: 600, exit: 300 }}
    >
      <CloseIconContainer>
        <CloseIcon onClick={closeWall} style={{ margin: '20px 20px 0 0', cursor: 'pointer' }} />
      </CloseIconContainer>

      {pageState === 'choose_plan' && (
        <>
          <PrewallLanding>
            {prewallObject?.videoId ? (
              <VideoContainer>
                <ReactPlayer
                  playing
                  muted
                  loop
                  width="100%"
                  height="100%"
                  url={prewallObject?.videoId}
                />
              </VideoContainer>
            ) : (
              <Advertisement src={`${mediaURL}${advertisementImage}`} />
            )}
            <PlanFlow>
              {prewallObject?.titleEnabled &&
                (prewallObject?.titles || []).map((titleObject) => {
                  return titleObject?.title.split('\\n').map((title, index) => {
                    return <PlanFlowTitle key={index}>{title}</PlanFlowTitle>
                  })
                })}
              {prewallObject?.headingEnabled && (
                <PlanFlowSubtitle>{prewallObject?.heading}</PlanFlowSubtitle>
              )}
              {validityState !== 'custom' && (
                <PlanValiditySelection>
                  {monthlyPlanObject?.[0] && (
                    <ValidityBox
                      selected={validityState === 'monthly'}
                      onClick={() => setValidityState('monthly')}
                    >
                      {localizedStrings?.monthly || 'Monthly'}{' '}
                    </ValidityBox>
                  )}
                  {yearlyPlanObject?.[0] && (
                    <ValidityBox
                      selected={validityState === 'yearly'}
                      onClick={() => setValidityState('yearly')}
                    >
                      {' '}
                      {localizedStrings?.yearly || 'Yearly'}{' '}
                    </ValidityBox>
                  )}
                </PlanValiditySelection>
              )}
              <PlanBox>
                <UpperContainer>
                  <PlanTitle>
                    <PlanLogo src={premium_logo} />
                    <BoxHeading>{planToShow?.title}</BoxHeading>
                  </PlanTitle>
                  <PriceBox onClick={() => setPageState('choose_payment_method')}>
                    <PlanPrice>
                      {planToShow?.currencySymbol ||
                        currency_list?.find((currency) => currency.code === planToShow?.currency)
                          ?.symbol}
                      {getPrice(planToShow)}
                    </PlanPrice>
                    {planToShow?.validity > 0 && <ValidityText>per month</ValidityText>}
                    {validityState === 'yearly' && (
                      <BilledAnnualText>*Billed Annually</BilledAnnualText>
                    )}
                  </PriceBox>
                </UpperContainer>
                <LowerContainer>
                  {prewallObject?.descEnabled && (
                    <ListContainer>
                      <TickList tickImage={tick_light}>
                        <span>{prewallObject?.descTitle}</span>
                        {(prewallObject?.descriptions || []).map((item, index) => {
                          return <li key={index}>{item}</li>
                        })}
                      </TickList>
                    </ListContainer>
                  )}
                  <PremiumMaskot src={premium_lady} />
                </LowerContainer>
              </PlanBox>
              <PremiumButton onClick={() => setPageState('choose_payment_method')}>
                {localizedStrings?.choose_premium || 'Choose Premium'}
              </PremiumButton>
            </PlanFlow>
          </PrewallLanding>

          {prewallObject?.comparisionEnabled && (
            <ComparisonContainer>
              <ComparisonTitle>{prewallObject?.comparisionTitle}</ComparisonTitle>

              <ComparisonTile background="#fff">
                <ComparisonMidText heading>{localizedStrings?.free || 'Free'}</ComparisonMidText>
                <ComparisonRightText heading>
                  <img src={unlimited_star} width="24px" />
                  {localizedStrings?.unlimited || 'Unlimited'}
                </ComparisonRightText>
              </ComparisonTile>

              {(prewallObject?.comparisions || []).map((item, index) => {
                return (
                  <ComparisonTile key={index} background={index % 2 == 0 ? '#EEE0FF' : '#fff'}>
                    <ComparisonLeftText>{item?.comparison}</ComparisonLeftText>
                    <ComparisonMidText>
                      {item?.comparisonType === 'text' ? (
                        item?.textForFreeUser
                      ) : (
                        <img src={paywall_cross} />
                      )}
                    </ComparisonMidText>
                    <ComparisonRightText>
                      {item?.comparisonType === 'text' ? (
                        item?.textForPremiumUser
                      ) : (
                        <img src={filled_tick} />
                      )}
                    </ComparisonRightText>
                  </ComparisonTile>
                )
              })}

              <ComparisonTile background="#fff">
                <ComparisonRightText>
                  <ComparisonButton plan onClick={() => setPageState('choose_payment_method')}>
                    {localizedStrings?.choose_plan || 'Choose Plan'}
                  </ComparisonButton>
                </ComparisonRightText>
              </ComparisonTile>
            </ComparisonContainer>
          )}

          {prewallObject?.reviewEnabled && testimonials?.length !== 0 && (
            <TestimonialContainer>
              <TestimonialHeading>{prewallObject?.reviewTitle}</TestimonialHeading>
              <TestimonialSubHeading>
                {localizedStrings?.testimonial_subheading || 'Discover user feedback on AUMHUM'}
              </TestimonialSubHeading>
              <ReviewBoxFirst>
                <ReviewBoxUpper>
                  <ReviewBoxImage src={review_image1} width="62px" />
                  <ReviewName>Fred</ReviewName>
                </ReviewBoxUpper>
                <ReviewBoxLower>{testimonials[0]?.comment}</ReviewBoxLower>
              </ReviewBoxFirst>
              <ReviewBoxSecond>
                <ReviewBoxUpper>
                  <ReviewBoxImage src={review_image2} width="70px" />
                  <ReviewName>Sarah</ReviewName>
                </ReviewBoxUpper>
                <ReviewBoxLower>{testimonials[1]?.comment}</ReviewBoxLower>
              </ReviewBoxSecond>
              <ReviewBoxThird>
                <ReviewBoxUpper>
                  <ReviewBoxImage src={review_image3} width="75px" />
                  <ReviewName>Connor</ReviewName>
                </ReviewBoxUpper>
                <ReviewBoxLower>{testimonials[2]?.comment}</ReviewBoxLower>
              </ReviewBoxThird>
              <ReviewBoxFourth>
                <ReviewBoxUpper>
                  <ReviewBoxImage src={review_image4} width="62px" />
                  <ReviewName>Dennis</ReviewName>
                </ReviewBoxUpper>
                <ReviewBoxLower>{testimonials[3]?.comment}</ReviewBoxLower>
              </ReviewBoxFourth>
              {prewallObject?.forWorkEnabled && (
                <ContainerForBusiness>
                  <CompanyLogo 
                    src={APP_CONSTANTS.APP_LOGO_LINK} 
                    onError={(e) => {
                      e.target.src = logo_brand
                    }}
                  />
                  <BusinessText>
                    <BusinessTextHeading>{prewallObject?.forWorkTitle}</BusinessTextHeading>
                    <BusinessTextSubHeading>{prewallObject?.forWorkSubtext}</BusinessTextSubHeading>
                  </BusinessText>
                  <ContactButton
                    onClick={() => (window.location.href = 'https://workplace.aumhum.com')}
                  >
                    {localizedStrings?.contact_us || 'Contact Us'}
                  </ContactButton>
                </ContainerForBusiness>
              )}
            </TestimonialContainer>
          )}
        </>
      )}

      {pageState === 'choose_payment_method' && (
        <PaymentMethodsContainerInPrewall>
          <GenericHeaderBackButton
            clickfunction={() => setPageState('choose_plan')}
            styles={{ cursor: 'pointer' }}
          />
          <div>
            <SubheadingPaymentsPage style={{ margin: '15px 0' }}>
              Choose a payment method:
            </SubheadingPaymentsPage>
            {masterListAllowedPaymentMethods.includes('razorpay') &&
              planToShow?.pymntGtyInfo?.find((item) => item?.pymntGtyId === 'razorpay') && (
                <PaymentMethodBox
                  onClick={() => {
                    handlePaymentMethodClick('razorpay')
                  }}
                >
                  <GenericDisplayFlex style={{ justifyContent: 'space-between' }}>
                    <GenericDisplayFlex>
                      <PaymentOptionImage
                        hideOnSmall
                        src={payment_options}
                      />
                      <PaymentOptionName>Razorpay</PaymentOptionName>
                    </GenericDisplayFlex>
                    <div>UPI, Credit and Debit Cards, Netbanking, and Wallets</div>
                    {paymentMethodLoading === 'razorpay' && (
                      <div>
                        <Spinner animation="border" variant="dark" size="sm" />
                      </div>
                    )}
                  </GenericDisplayFlex>
                </PaymentMethodBox>
              )}
            {masterListAllowedPaymentMethods.includes('stripe') &&
              planToShow?.pymntGtyInfo?.find((item) => item?.pymntGtyId === 'stripe') && (
                <PaymentMethodBox
                  onClick={() => {
                    handlePaymentMethodClick('stripe')
                  }}
                >
                  <GenericDisplayFlex style={{ justifyContent: 'space-between' }}>
                    <GenericDisplayFlex>
                      <PaymentOptionImage hideOnSmall src={stripe_logo} />
                      <PaymentOptionName>Stripe</PaymentOptionName>
                    </GenericDisplayFlex>
                    <div style={{ textAlign: 'right' }}>Credit and Debit Cards</div>
                    {paymentMethodLoading === 'stripe' && (
                      <div>
                        <Spinner animation="border" variant="dark" size="sm" />
                      </div>
                    )}
                  </GenericDisplayFlex>
                </PaymentMethodBox>
              )}
            {masterListAllowedPaymentMethods.includes('giftup') &&
              planToShow?.pymntGtyInfo?.find((item) => item?.pymntGtyId === 'gift_up') && (
                <>
                  <SubheadingPaymentsPage style={{ marginTop: '20px' }}>
                    Have a gift card? Enter details in the box below:
                  </SubheadingPaymentsPage>

                  <GiftCodeInputContainer
                    style={{ marginTop: '10px', width: '100%', maxWidth: '450px' }}
                  >
                    <GiftCardInput value={giftCode} onChange={(e) => setGiftCode(e.target.value)} />
                    <GiftCodeSubmitButton
                      src={submit_button_purple}
                      onClick={() => {
                        if (!Boolean(paymentMethodLoading)) {
                          setGiftCodeError(false)
                          payUsingGiftCardInPrewall(
                            giftCode,
                            (error) => setGiftCodeError(error),
                            () => setPageState('successful'),
                            (string) => setPaymentMethodLoading(string),
                          )
                        }
                      }}
                    />
                  </GiftCodeInputContainer>

                  {paymentMethodLoading === 'giftcard' && (
                    <Spinner animation="border" variant="dark" size="sm" />
                  )}
                  {giftCodeError && <ErrorMessage>{giftCodeError}</ErrorMessage>}
                </>
              )}
          </div>
        </PaymentMethodsContainerInPrewall>
      )}

      {pageState === 'successful' && (
        <PaymentMethodsContainerInPrewall>
          <div
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}
          >
            <TickLottie animationData={confirmationTickLottie} loop={false} autoPlay={true} />
            <HeadingConfirmationPage>
              {planToShow?.subscriptionSuccessMsg ||
                'Congratulations! You are now an AUMHUM member'}
            </HeadingConfirmationPage>
            <div
              style={{ fontWeight: '500', cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => window.location.reload()}
            >
              Refresh my experience
            </div>
          </div>
        </PaymentMethodsContainerInPrewall>
      )}
    </StyledPrewallDrawer>
  )
}

function getPrice(plan) {
  const priceToUse = plan?.validity > 0 ? plan?.finalPrice * 30 : plan?.finalPrice
  const planValidity = plan?.validity > 0 ? plan?.validity : 1
  const price = priceToUse / planValidity

  return price.toFixed(2)
}

export default PrewallAndPaywall

async function payUsingGiftCardInPrewall(
  giftCode,
  giftCodeErrorSetter,
  afterConfirmationFunction,
  loadingSetter,
) {
  loadingSetter('giftcard')
  const response = await putDataWithParams(
    '/api/secure/purchase/packages',
    {},
    { giftCode: giftCode },
  )
  loadingSetter(null)
  if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    afterConfirmationFunction()
  } else {
    giftCodeErrorSetter(response?.response?.data?.message)
  }
}
